import { render, staticRenderFns } from "./biometricVerification.vue?vue&type=template&id=58abd5e5&"
import script from "./biometricVerification.vue?vue&type=script&lang=js&"
export * from "./biometricVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports